import React from 'react';
import styled from '@emotion/styled';

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 15px;
  width: ${(props) => props.widthPercentage};
`;

const Label = styled.label`
  font-size: 0.8rem;
  margin-bottom: 5px;
  text-align: left;
`;

const TextArea = styled.textarea`
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
  height: auto;
  min-height: 100px;
  background-color: ${props => props.missing ? '#ffdddd' : 'white'};
  resize: vertical;
`;

const ErrorMessage = styled.span`
  bottom: 0;
  color: #880808;
  font-size: 12px;
`;

const RichTextBoxWithLabel = ({
  label,
  optional = false,
  width = '100%',
  value,
  onChange,
  required = false,
  missing = false,
  invalidData,
  disabled = false,
  ...textAreaProps
}) => {
  return (
    <InputContainer widthPercentage={width}>
      <Label>
        {label}
        {required && <span style={{ color: '#880808' }}> *</span>}
        {optional && <span style={{ color: '#727272' }}> (optional)</span>}
      </Label>
      <TextArea value={value} onChange={onChange} missing={missing} disabled={disabled} {...textAreaProps} />
      {invalidData && <ErrorMessage>{invalidData}</ErrorMessage>}
    </InputContainer>
  );
};

export default RichTextBoxWithLabel;
